<template>
	<div class="arrow-button" :class="type+' arrow-button-'+color">

		<span>{{label}}</span>


			<svg v-if="!type && color == 'orange'" xmlns="http://www.w3.org/2000/svg" width="229.813" height="88.035" viewBox="0 0 229.813 88.035">
				<g id="Raggruppa_216" data-name="Raggruppa 216" transform="translate(3 3)">
					<g id="Raggruppa_217" data-name="Raggruppa 217">
						<path id="Tracciato_632" data-name="Tracciato 632" d="M18.36,0H176.3a19.591,19.591,0,0,1,12.609,4.481l29.149,24.61a15.241,15.241,0,0,1,0,23.852L188.912,77.554A19.591,19.591,0,0,1,176.3,82.035H18.36C8.22,82.035,0,74.69,0,65.628V16.407C0,7.346,8.22,0,18.36,0" fill="#ff9a00" stroke="#fff" stroke-width="6"/>
					</g>
				</g>
			</svg>

			<svg v-if="!type && color == 'pink'" xmlns="http://www.w3.org/2000/svg" width="229.813" height="88.035" viewBox="0 0 229.813 88.035">
				<g id="Raggruppa_216" data-name="Raggruppa 216" transform="translate(3 3)">
					<g id="Raggruppa_217" data-name="Raggruppa 217">
						<path id="Tracciato_632" data-name="Tracciato 632" d="M18.36,0H176.3a19.591,19.591,0,0,1,12.609,4.481l29.149,24.61a15.241,15.241,0,0,1,0,23.852L188.912,77.554A19.591,19.591,0,0,1,176.3,82.035H18.36C8.22,82.035,0,74.69,0,65.628V16.407C0,7.346,8.22,0,18.36,0" fill="#f251a5" stroke="#fff" stroke-width="6"/>
					</g>
				</g>
			</svg>
			
			<svg v-if="type == 'left'" xmlns="http://www.w3.org/2000/svg" width="229.787" height="88.035" viewBox="0 0 229.787 88.035">
				<g id="Raggruppa_216" data-name="Raggruppa 216" transform="translate(226.787 85.035) rotate(180)">
					<g id="Raggruppa_217" data-name="Raggruppa 217">
					<path id="Tracciato_632" data-name="Tracciato 632" d="M18.36,0H176.3a19.591,19.591,0,0,1,12.609,4.481l29.149,24.61a15.229,15.229,0,0,1,2.325,21.476,16.442,16.442,0,0,1-2.325,2.375L188.912,77.554A19.591,19.591,0,0,1,176.3,82.035H18.36C8.22,82.035,0,74.69,0,65.628V16.407C0,7.346,8.22,0,18.36,0" fill="#d8e7ff" stroke="#3384ff" stroke-width="6"/>
					</g>
				</g>
			</svg>


			<svg v-if="type == 'confirm'" xmlns="http://www.w3.org/2000/svg" width="227" height="88" viewBox="0 0 227 88">
				<g id="Rettangolo_78" data-name="Rettangolo 78" fill="#e3facc" stroke="#1d9c62" stroke-width="6">
					<rect width="227" height="88" rx="20" stroke="none"/>
					<rect x="3" y="3" width="221" height="82" rx="17" fill="none"/>
				</g>
			</svg>
			
		</div>
</template>
<script>
export default {
	props: ['label', 'type','color'],
}
</script>
<style scoped lang="scss">
	.arrow-button {
		cursor: pointer;
		text-transform: uppercase;
		color: #fff;
		position: relative;
		width: px(200);
		height: px(100);
		align-items: center;

		&.arrow-button-orange {
			&:hover {
				color: $mondadori-orange;
			}
			&.left:hover span {
				color: $mondadori-orange;
			}
			&.confirm {
				span {
					color: $mondadori-orange;
				}
			}
		}

		&.arrow-button-pink {
			&:hover {
				color: $mondadori-pink;
			}
			&.left:hover span {
				color: $mondadori-pink;
			}
			&.confirm {
				span {
					color: $mondadori-pink;
				}
			}
		}

		

		&.left {
			span {
				width: 100%;
				text-align: center;
				color: $mondadori-blue;
			}
		}
		&.confirm {
			span {
				width: 100%;
				text-align: center;
				color: $mondadori-green;
				left: 0;
			}
		}

		&:hover {
			svg * {
				fill: #fff;
			}
			
		}
		span {
			position: absolute;
			z-index: 10;
			top: 50%;
			left: px(15);
			transform: translateY(-50%);
			line-height: 1;
			@include breakpoint(s) {
				font-size: px(16)
			}
		}
		svg {
			position: absolute;
			top: 0;
			width: 100%;
			height: 100%;
			bottom: 0;
			left: 0;
			right: 0;
		}
	}
</style>